//

import { api } from "./api";

export const enquiryList = async (addUrl = ``) => {
  return await api.get(`/enquiries?${addUrl}`);
};

export const enquiryNoVerify = async (addUrl = "") => {
  return await api.get(`/enquiry/no/verify?${addUrl}`);
};

export const enquiryAdd = async (data) => {
  return await api.post(`/enquiry/add`, data);
};

export const enquiryUpdate = async (data) => {
  return await api.post(`/enquiry/update`, data);
};
export const enquiryStatusChange = async (data) => {
  return await api.post(`/enquiry/status/change`, data);
};

export const enquiryDelete = async (id) => {
  return await api.post(`/enquiry/delete`, { id });
};

export const enquiryDetail = async (id) => {
  return await api.get(`/enquiry/detail?id=${id}`);
};

export const enquiryReport = async (addUrl = "") => {
  return await api.get(`/enquiry/report?${addUrl}`);
};
